import SplitHero from "../Generic/SplitHero";
import { isLoggedIn as checkLogin } from "../../utility/UserUtils";
import { useNavigate } from "react-router-dom";

const StorytellingHero = () => {
  const navigate = useNavigate();
  const isLoggedIn = checkLogin();

  return (
    <SplitHero
      title="WISE STORYTELLING"
      description="WiSE Storytelling brings together voices from across the ecosystem through thoughtfully curated online sessions that connect our community across locations and career stages."
      imageSrc="/assets/stroytelling/storytellingherobg.png"
      imagePosition="right"
      buttonText={!isLoggedIn ? "Join the WiSE Storytelling Community" : null}
      onButtonClick={() => navigate("/signup")}
       variant="split"
    />
  );
};

export default StorytellingHero;
